import { Duration } from 'luxon'

export const formatDuration = (time: number) => {
  const dur = Duration.fromObject({ seconds: time }).shiftTo('hours', 'minutes', 'seconds').toObject()
  return`${dur.hours !== 0 ? dur.hours + 'h ' : ''}${dur.minutes !== 0 ? dur.minutes + 'm ' : ''}`
}
